import React from 'react';
import './Card.css';

export interface CardProps {
  title?: string;
  subtitle?: string;
  headerRight?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  padding?: boolean;
  className?: string;
}

export function Card({ title, subtitle, headerRight, footer, children, padding = true, className = '' }: CardProps) {
  return (
    <div className={`ui-card ${className}`}>
      {(title || headerRight) && (
        <div className="ui-card-header">
          <div>
            {title && <h3 className="ui-card-title">{title}</h3>}
            {subtitle && <p className="ui-card-subtitle">{subtitle}</p>}
          </div>
          {headerRight && <div className="ui-card-header-right">{headerRight}</div>}
        </div>
      )}
      <div className={`ui-card-body ${padding ? '' : 'ui-card-no-pad'}`}>{children}</div>
      {footer && <div className="ui-card-footer">{footer}</div>}
    </div>
  );
}
